module.exports = __webpack_public_path__ + "static/media/logo.2bd7028c.png";